import PeopleCircles from '@/components/PeopleCircles'
import type { Person } from '@/lib/person'

// One people card on the request form (In charge / Reviewers): same shell
// as ReviewersCard, with the copy passed in.
export default function RequestPeopleCard({ title, description, pickerTitle, people, selectedIds, onChange, warning }: {
  title: string; description: string; pickerTitle: string
  people: Person[]; selectedIds: string[]; onChange: (ids: string[]) => void; warning?: string | null
}) {
  return (
    <div style={{ background: 'var(--background)', borderColor: 'var(--border)' }} className="min-w-0 rounded-lg border p-5">
      <h2 className="text-lg font-semibold leading-snug tracking-tight text-foreground">{title}</h2>
      <p className="mt-0.5 text-[13px] text-muted-foreground">{description}</p>
      <div className="mt-3">
        <PeopleCircles title={pickerTitle} people={people} selectedIds={selectedIds} onChange={onChange} editable />
      </div>
      {warning && <p className="mt-2 text-[13px] text-warning">{warning}</p>}
    </div>
  )
}
